import { render, staticRenderFns } from "./edit-appointment.vue?vue&type=template&id=4ecd2090&"
import script from "./edit-appointment.vue?vue&type=script&lang=js&"
export * from "./edit-appointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports